// Mock data for The Blanket Project

export const teamMembers = [
  {
    id: 1,
    name: "Sean Talluri",
    role: "Founder & Minister",
    image: "https://customer-assets.emergentagent.com/job_dallas-blankets/artifacts/4lqmjynk_Sean%20Profile%20pic.png",
    bio: "Sean was saved by God's grace at 18 and experienced deep spiritual transformation. He combines his passion for technology and ministry to serve God's kingdom through biblical teaching, fellowship, and discipleship. His motto from Philippians 4:13: 'I can do all things through Christ who strengthens me.'",
    qualifications: [
      "MA in Biblical Exposition - Liberty University (2024)",
      "Currently pursuing D.Min in Expository Preaching and Teaching",
      "Director of Product at Upbound Group",
      "Professor of Product Management at Dallas Baptist University"
    ]
  },
  {
    id: 2,
    name: "Rhoda Talluri", 
    role: "Co-Founder & Ministry Director",
    image: "https://customer-assets.emergentagent.com/job_dallas-blankets/artifacts/zpxu6pmy_WhatsApp%20Image%202025-09-22%20at%2018.44.05.jpeg",
    bio: "Rhoda is a cornerstone in spiritual and community life, nurturing young members with dedication and love. She serves patients as a Physical Therapist while actively supporting ministry initiatives alongside Sean.",
    qualifications: [
      "Physical Therapist at UT Southwestern Medical Center",
      "Ministry Co-Director at El Bethel Ministries"
    ]
  }
];

export const services = [
  {
    id: 1,
    icon: "Heart",
    title: "Blanket Distribution",
    description: "Providing warm blankets to those facing harsh weather conditions, ensuring comfort and dignity for our community members in need."
  },
  {
    id: 2,
    icon: "Utensils",
    title: "Food Outreach",
    description: "Distributing nutritious meals and food supplies to individuals and families experiencing food insecurity in the Dallas metro area."
  },
  {
    id: 3,
    icon: "Package",
    title: "Sanitary Supplies",
    description: "Essential hygiene products and sanitary supplies to maintain health and dignity for underserved community members."
  }
];

export const volunteerOpportunities = [
  {
    id: 1,
    title: "Distribution Volunteer",
    commitment: "4 hours/month",
    description: "Help distribute blankets, food, and supplies directly to community members during our regular outreach events."
  },
  {
    id: 2,
    title: "Supply Organizer",
    commitment: "2-3 hours/week",
    description: "Sort, organize, and prepare donated items for distribution. Perfect for those who prefer working behind the scenes."
  },
  {
    id: 3,
    title: "Outreach Coordinator",
    commitment: "Flexible",
    description: "Help coordinate outreach events, connect with community partners, and spread awareness about our mission."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Maria Gonzalez",
    role: "Community Member",
    quote: "The Blanket Project came to our neighborhood during the coldest week of winter. The warmth they provided wasn't just from the blankets - it was from their genuine care and love.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face"
  },
  {
    id: 2,
    name: "John Smith", 
    role: "Volunteer",
    quote: "Volunteering with The Blanket Project has been one of the most rewarding experiences. Seeing the direct impact we make in people's lives is incredible.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&crop=face"
  },
  {
    id: 3,
    name: "Pastor Williams",
    role: "Community Partner",
    quote: "The Blanket Project exemplifies Christ's love in action. Their dedication to serving the least among us is truly inspiring to our entire community.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=face"
  }
];

export const contactInfo = {
  address: "1601 E Lamar Blvd, Ste 214-1288",
  city: "Arlington, TX 76011",
  email: "contact@theblanket.us",
  phone: "(555) 123-4567", // Mock phone number
  socialMedia: {
    facebook: "https://facebook.com/blanketproject",
    instagram: "https://instagram.com/blanketproject",
    twitter: "https://twitter.com/blanketproject"
  }
};

export const faqData = [
  {
    id: 1,
    question: "How can I volunteer with The Blanket Project?",
    answer: "We welcome volunteers of all backgrounds! You can sign up through our volunteer form, attend our monthly volunteer orientation, or contact us directly. We have opportunities for both regular commitments and one-time events."
  },
  {
    id: 2,
    question: "What items do you need most?",
    answer: "Currently, we need new or gently used blankets, non-perishable food items, toiletries, and hygiene products. Please check our current needs list as priorities may change seasonally."
  },
  {
    id: 3,
    question: "How do you select who receives assistance?",
    answer: "We serve anyone in need within the Dallas metro area, with no requirements other than genuine need. Our outreach focuses on areas with high concentrations of underserved populations, homeless individuals, and vulnerable families."
  },
  {
    id: 4,
    question: "How can I donate items to support your mission?",
    answer: "We accept material donations of blankets, food, hygiene supplies, and other essential items. Please contact us to coordinate drop-off times and locations, or to learn about our current most needed items."
  }
];

export const stats = [
  {
    number: "500+",
    label: "Blankets Planned for Distribution"
  },
  {
    number: "12",
    label: "Community Partnerships"
  },
  {
    number: "50+", 
    label: "Volunteer Applications"
  },
  {
    number: "3",
    label: "Service Areas"
  }
];